import { render, staticRenderFns } from "./BuddhismDetail.vue?vue&type=template&id=3321d936&scoped=true"
import script from "./BuddhismDetail.vue?vue&type=script&lang=js"
export * from "./BuddhismDetail.vue?vue&type=script&lang=js"
import style0 from "./BuddhismDetail.vue?vue&type=style&index=0&id=3321d936&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3321d936",
  null
  
)

export default component.exports